import { render, staticRenderFns } from "./NewFabricStock-in.vue?vue&type=template&id=3537cdb7&"
import script from "./NewFabricStock-in.vue?vue&type=script&lang=js&"
export * from "./NewFabricStock-in.vue?vue&type=script&lang=js&"
import style0 from "./NewFabricStock-in.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports